import { useState } from "react";
import { Countdown } from "../components/Countdown";
import { HoldToReveal } from "../components/HoldToReveal";
import { PhaseHeader } from "../components/PhaseHeader";
import { RoleCardView } from "../components/RoleCardView";
import { useCommand } from "../hooks/useCommand";
import type { PlayerView } from "../protocol";
import { useGame } from "../state/store";

const WIN_TEXT = {
  good: "You are Good. Find the Demon and execute them.",
  evil: "You are Evil. Stay hidden until only two players are left alive.",
};

export function RoleRevealScreen({ view }: { view: PlayerView }) {
  const roles = useGame((s) => s.roles);
  const { run, busy } = useCommand();
  const [seen, setSeen] = useState(false);
  const role = view.private.role;
  const acked = view.private.role_acked;
  const setup = view.setup;

  return (
    <main className="screen">
      <PhaseHeader view={view} roles={roles} showRole={false} showNotebook={false} />
      <div className="stack center">
        <h2>Your role</h2>
        <p className="muted small">Only you can see this. Keep it secret.</p>
      </div>
      {role && (
        <HoldToReveal onRevealed={() => setSeen(true)}>
          <div className="stack">
            <RoleCardView role={role} alignment={view.private.alignment} />
            <p className="small">{WIN_TEXT[view.private.alignment ?? role.team]}</p>
          </div>
        </HoldToReveal>
      )}
      <div className="grow" />
      <div className="bottom-bar">
        {acked ? (
          <p className="muted center">
            Waiting for everyone
            {setup ? ` (${setup.acked_count}/${setup.total})` : ""}
            {setup?.deadline_ms ? (
              <>
                {" · night falls in "}
                <Countdown deadline={setup.deadline_ms} />
              </>
            ) : null}
          </p>
        ) : (
          <>
            <button
              className="btn btn-primary"
              disabled={!seen || busy}
              onClick={() => run({ type: "ack_role" })}
            >
              I know my role
            </button>
            {!seen && <p className="tiny faint center">Hold the card above to see your role first.</p>}
          </>
        )}
      </div>
    </main>
  );
}
